import { render, staticRenderFns } from "./MsDropDownItem.vue?vue&type=template&id=5d85066e&scoped=true&lang=html"
import script from "./MsDropDownItem.vue?vue&type=script&lang=js"
export * from "./MsDropDownItem.vue?vue&type=script&lang=js"
import style0 from "./MsDropDownItem.vue?vue&type=style&index=0&id=5d85066e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85066e",
  null
  
)

export default component.exports